import ParticlesBg from "particles-bg";
import top from "../us.png";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <ParticlesBg
          type="lines"
          color="#ffffff"
          bg={{ zIndex: 0, position: "absolute", top: 0 }}
        />

        <div className="overlay">
          <div className="container">
            <div className="row">
              <div
                className="col-md-8 col-md-offset-2 intro-text"
                style={{ paddingBottom: "80px", paddingTop: "150px" }}
              >
                <h1 style={{ color: "#00a0cb" }}>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p style={{ color: "#00a0cb", fontWeight: "bold" }}>
                  {props.data ? props.data.paragraph : "Loading"}
                </p>
                <img src={top} alt="img" width={500} />
                <br />
                <br />
                <a
                  href="#calltoaction"
                  className="btn btn-custom btn-lg page-scroll"
                  style={{ backgroundColor: "#00a0cb" }}
                >
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
